import { reduce } from "et3-type-guards";

import i18n from "../../../../../constants/i18n";
import ET3Div from "../../../../../core/et3-div";
import Et3Image from "../../../../../core/et3-Image";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";

const StripeHistoryBadge = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const advancedStore = getUserAdvancedStore();
  const userId = advancedStore.currentUserId.get();
  const data = advancedStore.userData.get(userId);
  const wasStripeUser = reduce(() => data.wasStripeUser, false);

  return wasStripeUser ? (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={0}
      height={0}
      fDirection="row"
      alignItems="center"
      justifyContent="flex-end"
      color={colors.all.transparent}
      style={{ width: "100%" }}
      onClick={() => {}}
    >
      <Et3Image
        imageName="stripe-logo"
        alt={i18n.get("WAS_STRIPE_USER")}
        size={45}
        type="LOCAL"
        onClick={() => {}}
        style={{ borderRadius: "20%" }}
      />
    </ET3Div>
  ) : null;
});
export default StripeHistoryBadge;
